module.exports = __webpack_public_path__ + "img/13.d4828a0e.jpg";